"use strict";
/**
 * Emoji storage for recent & common emojis
 * Spec: Most recent emojis used, My most common emojis
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordEmojiUsed = exports.getCommonEmojis = exports.getRecentEmojis = void 0;
const RECENT_KEY = 'mango_chat_emoji_recent';
const COUNTS_KEY = 'mango_chat_emoji_counts';
const MAX_RECENT = 24;
const MAX_COMMON = 12;
// Default common emojis (most used in messaging)
const DEFAULT_COMMON = ['👍', '❤️', '😂', '😊', '🎉', '🔥', '👋', '😀', '🙏', '💪', '✨', '😍'];
function getRecentEmojis() {
    try {
        const raw = localStorage.getItem(RECENT_KEY);
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
}
exports.getRecentEmojis = getRecentEmojis;
function getCommonEmojis() {
    try {
        const counts = getEmojiCounts();
        if (Object.keys(counts).length === 0)
            return DEFAULT_COMMON;
        const sorted = Object.entries(counts)
            .sort(([, a], [, b]) => b - a)
            .slice(0, MAX_COMMON)
            .map(([emoji]) => emoji);
        return sorted.length > 0 ? sorted : DEFAULT_COMMON;
    }
    catch {
        return DEFAULT_COMMON;
    }
}
exports.getCommonEmojis = getCommonEmojis;
function getEmojiCounts() {
    try {
        const raw = localStorage.getItem(COUNTS_KEY);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
}
function recordEmojiUsed(emoji) {
    const recent = getRecentEmojis();
    const nextRecent = [emoji, ...recent.filter((e) => e !== emoji)].slice(0, MAX_RECENT);
    localStorage.setItem(RECENT_KEY, JSON.stringify(nextRecent));
    const counts = getEmojiCounts();
    counts[emoji] = (counts[emoji] || 0) + 1;
    localStorage.setItem(COUNTS_KEY, JSON.stringify(counts));
}
exports.recordEmojiUsed = recordEmojiUsed;
